"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29660],{

/***/ 98183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31567);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72063);
/* harmony import */ var _googlemaps_js_api_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33311);
/* harmony import */ var react_geosuggest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83509);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96149);
/* provided dependency */ var process = __webpack_require__(34155);











var loader = new _googlemaps_js_api_loader__WEBPACK_IMPORTED_MODULE_6__/* .Loader */ .a({
    apiKey: "AIzaSyDa1-c6W1j-IzqW9gmpFe1mlciR-nKoMuE",
    version: 'weekly',
    libraries: [
        'places'
    ]
});
var MIN_LENGHT_SEARCH = 5;
var excludedPlaces = process.env.EXCLUDED_SHIPPING_PLACES;
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        root: {
            position: 'relative',
            '& .geosuggest': {
                position: 'relative',
                '&__input': {
                    display: 'block',
                    width: '100%',
                    margin: 'auto',
                    padding: theme.spacing(1, 1.25),
                    fontFamily: theme.typography.fontFamily,
                    fontSize: 14,
                    borderRadius: 6,
                    border: "1px solid ".concat(theme.extraColors.greyLight),
                    color: theme.typography.body1.color,
                    backgroundColor: theme.extraColors.greyLight,
                    WebkitAppearance: 'none',
                    '&::placeholder': {
                        opacity: 0.75,
                        color: theme.typography.body1.color
                    },
                    '&:disabled': {
                        userSelect: 'none',
                        cursor: 'not-allowed'
                    }
                },
                '&__suggests': {
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                    left: 0,
                    right: 0,
                    top: '100%',
                    zIndex: theme.zIndex.appBar,
                    background: theme.palette.common.white,
                    boxShadow: theme.shadows[1],
                    borderRadius: theme.shape.borderRadius,
                    '&--hidden': {
                        display: 'none'
                    },
                    '&-wrapper': {}
                },
                '&__item': {
                    padding: theme.spacing(1, 1.25),
                    cursor: 'pointer',
                    borderBottom: "1px solid ".concat(theme.extraColors.greyLight),
                    '&:hover, &:focus, &--active': {
                        background: theme.extraColors.greyLight
                    },
                    '&:last-child': {
                        border: 0
                    }
                }
            }
        },
        label: {
            display: 'block',
            cursor: 'pointer',
            textAlign: 'inherit',
            fontSize: 11,
            marginLeft: theme.spacing(1.25),
            marginBottom: theme.spacing(0.5)
        },
        rootLoading: {
            position: 'relative',
            minHeight: '3em'
        },
        errorContainer: {
            minHeight: '2em',
            marginTop: theme.spacing(1)
        },
        error: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
            '& p': {
                margin: 0
            }
        },
        errorColor: {
            borderColor: theme.palette.error.main,
            color: theme.palette.error.main
        },
        overlay: {
            position: 'absolute',
            zIndex: theme.zIndex.appBar,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(255,255,255, .5)',
            backdropFilter: 'blur(2px)'
        }
    });
});
var mapStateToProps = function(state) {
    return {
        parameters: state.parameters
    };
};
var GoogleMapsApi = function(param) {
    var parameters = param.parameters, datas = param.datas, label = param.label, placeholder = param.placeholder, saveSearchAddress = param.saveSearchAddress, changeZipCode = param.changeZipCode, carrierId = param.carrierId, type1 = param.type, value = param.value;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)().t;
    var countries = parameters === null || parameters === void 0 ? void 0 : parameters.countries;
    var classes = useStyles();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), searchReady = ref5[0], setSearchReady = ref5[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), noResults = ref1[0], setNoResults = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), areaError = ref2[0], setAreaError = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), countryError = ref3[0], setCountryError = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), searchError = ref4[0], setSearchError = ref4[1];
    // TODO change this to configuration with env var or parmameter to use it with other stores
    var noPostalCode = "maje_2ndhand" === 'chalhoub';
    var countryCodes = [];
    countries === null || countries === void 0 ? void 0 : countries.forEach(function(country) {
        return countryCodes.push(country.code.toLowerCase());
    });
    var handleSelect = function(suggest) {
        var ref6;
        setNoResults(false);
        var countryCode;
        var country1;
        var postalcode;
        var city;
        var streetnumber;
        var street;
        var area;
        var areaCode;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var details;
        // First fill street with suggest.gmaps.name for not revelant adresses (ex: allée de la Cascade, Arnas, France)
        street = suggest === null || suggest === void 0 ? void 0 : (ref6 = suggest.gmaps) === null || ref6 === void 0 ? void 0 : ref6.name;
        // Second go through each address_component types and fill each vars.
        // street will be redefined if type 'route' exist (ex: 15 rue de milan)
        suggest === null || suggest === void 0 ? void 0 : suggest.gmaps.address_components.forEach(function(address_component) {
            address_component.types.forEach(function(type) {
                if (type === 'country') {
                    var ref;
                    countryCode = address_component.short_name;
                    country1 = ((ref = countries.find(function(country) {
                        return country.code === countryCode;
                    })) === null || ref === void 0 ? void 0 : ref.name) || address_component.long_name;
                }
                if (type === 'postal_code') {
                    postalcode = address_component.long_name;
                }
                if (type === 'locality' || type === 'postal_town') {
                    city = address_component.long_name;
                }
                if (type === 'sublocality_level_1') {
                    details = address_component.long_name;
                }
                if (type === 'street_number') {
                    streetnumber = address_component.long_name;
                }
                if (type === 'route') {
                    street = address_component.long_name;
                }
                if (type === 'administrative_area_level_1') {
                    area = address_component.long_name;
                    areaCode = address_component.short_name;
                }
            });
        });
        // if (details) {
        //   street = street + ' - ' + details
        // }
        var isValidCountry = countryCodes.includes(countryCode && countryCode.toLowerCase());
        var handleAddressDetail = function() {
            var addressDetail = {
                hasHouseNumber: !!streetnumber,
                streetNumber: streetnumber,
                street: street,
                city: city,
                area: area,
                areaCode: areaCode,
                postcode: postalcode,
                country_code: countryCode,
                country: country1
            };
            changeZipCode && changeZipCode(city, postalcode, carrierId, countryCode, type1, street);
            saveSearchAddress && saveSearchAddress(addressDetail);
        };
        var isExcludedArea = excludedPlaces && excludedPlaces.split(',').includes(area && area);
        if (noPostalCode) {
            postalcode = '-';
        }
        var isAddressValid = countryCode !== 'AE' && saveSearchAddress && street && postalcode || changeZipCode && city && postalcode || countryCode === 'AE' && saveSearchAddress && street || changeZipCode && city;
        // First check if result is in a valid country
        if (isValidCountry) {
            setCountryError(false);
            // Second check if result is in an excluded area
            if (isExcludedArea) {
                setAreaError(true);
            } else {
                setAreaError(false);
                if (isAddressValid) {
                    handleAddressDetail();
                    setSearchError(false);
                } else {
                    setSearchError(true);
                }
            }
        } else {
            setCountryError(true);
        }
    };
    var handleNoResults = function(userInput) {
        if (userInput.length > MIN_LENGHT_SEARCH) {
            setNoResults(true);
        }
        setCountryError(false);
        setSearchError(false);
        setAreaError(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        loader.load().then(function() {
            return setSearchReady(true);
        }).catch(function() {
            return setSearchReady(false);
        });
    }, [
        searchReady
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: searchReady ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('searchApp', classes.root),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: 'geosuggest__input',
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('label', classes.label),
                    children: label
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_geosuggest__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    inputType: 'search',
                    minLength: MIN_LENGHT_SEARCH,
                    placeholder: placeholder,
                    onSuggestSelect: handleSelect,
                    initialValue: value,
                    onSuggestNoResults: handleNoResults,
                    onUpdateSuggests: function() {
                        return setNoResults(false);
                    },
                    country: (countryCodes === null || countryCodes === void 0 ? void 0 : countryCodes.length) > 5 ? null : countryCodes
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.errorContainer,
                    children: [
                        noResults && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            in: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classes.error,
                                "data-searchstate": "search-noresults",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        color: 'error'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classes.errorColor,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                            data: datas === null || datas === void 0 ? void 0 : datas.no_results,
                                            defaultText: t('texts:general:search_address:no_results')
                                        })
                                    })
                                ]
                            })
                        }),
                        areaError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            in: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classes.error,
                                "data-searchstate": "search-invalid-country",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        color: 'error'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classes.errorColor,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                            data: datas === null || datas === void 0 ? void 0 : datas.excluded,
                                            defaultText: t('texts:general:search_address:excluded')
                                        })
                                    })
                                ]
                            })
                        }),
                        countryError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            in: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classes.error,
                                "data-searchstate": "search-invalid-country",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        color: 'error'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classes.errorColor,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                            data: datas === null || datas === void 0 ? void 0 : datas.invalid_country,
                                            defaultText: t('texts:general:search_address:invalid_country')
                                        })
                                    })
                                ]
                            })
                        }),
                        searchError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            in: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classes.error,
                                "data-searchstate": "search-incomplete",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        color: 'error'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classes.errorColor,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                            data: datas === null || datas === void 0 ? void 0 : datas.incomplete,
                                            defaultText: t('texts:general:search_address:incomplete')
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('searchApp', classes.rootLoading),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.overlay,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader_Loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps)(GoogleMapsApi));


/***/ }),

/***/ 12907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Information_AddressForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./redux/reducers/addressReducer.tsx
var addressReducer = __webpack_require__(63593);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
// EXTERNAL MODULE: ./hooks/useAddress.ts + 1 modules
var useAddress = __webpack_require__(59361);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./components/Information/AreaAddressForm.tsx









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            margin: theme.spacing(0, 0, 2)
        },
        form: {},
        formContent: _defineProperty({
            margin: theme.spacing(0, 0, 2)
        }, theme.breakpoints.up('md'), {
            padding: theme.spacing(0, 2)
        }),
        cardTitle: {
            textAlign: 'center',
            marginBottom: theme.spacing(1)
        },
        success: {
            color: theme.palette.success.main
        },
        changeButton: _defineProperty({
            padding: theme.spacing(1, 3),
            margin: theme.spacing(1, 0)
        }, theme.breakpoints.down('md'), {
            padding: theme.spacing(1, 2)
        })
    });
});
var AreaAddressForm = function(param) {
    var _prefill = param.prefill, prefill = _prefill === void 0 ? false : _prefill, addressType = param.addressType, className = param.className;
    var formatPayloadAddress = function formatPayloadAddress(inputAddress) {
        var street = inputAddress.street, area = inputAddress.area, city = inputAddress.city;
        var isValid = Boolean(street && area && city);
        var payloadAddress;
        if (isValid) {
            payloadAddress = {
                street: street,
                postcode: area,
                city: city,
                countryCode: 'AE'
            };
        }
        return {
            payloadAddress: payloadAddress,
            isValid: isValid
        };
    };
    var initAreaAddress = function initAreaAddress(shippingAddress) {
        if (prefill && shippingAddress) {
            return {
                street: shippingAddress.street,
                area: shippingAddress.postcode,
                city: shippingAddress.city
            };
        }
        return {
            street: '',
            area: '',
            city: ''
        };
    };
    var onChange = function onChange(value, key) {
        saveInputAddress(_objectSpread({}, inputAddress1, _defineProperty({}, key, value)));
    };
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = useStyles();
    var prismicAccount = (0,es/* useSelector */.v9)(function(state) {
        return state.prismic.account;
    });
    var ref = (0,useAddress/* useAddress */.S)(addressType, initAreaAddress, formatPayloadAddress), address = ref.address, saveInputAddress = ref.saveInputAddress;
    var inputAddress1 = address.input;
    var text = function(key) {
        return (0,CMSText/* prismicText */.yz)(prismicAccount[key], t("texts:account:area_address:".concat(key)));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: text('label_city'),
                        placeholder: text('placeholder_city'),
                        type: "text",
                        name: "address_details",
                        value: inputAddress1 === null || inputAddress1 === void 0 ? void 0 : inputAddress1.city,
                        onChange: function(value) {
                            return onChange(value, 'city');
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: text('label_area'),
                        placeholder: text('placeholder_area'),
                        type: "text",
                        name: "address_details",
                        value: inputAddress1 === null || inputAddress1 === void 0 ? void 0 : inputAddress1.area,
                        onChange: function(value) {
                            return onChange(value, 'area');
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: text('label_address_details'),
                        placeholder: text('placeholder_address_details'),
                        type: "text",
                        name: "address_details",
                        value: inputAddress1 === null || inputAddress1 === void 0 ? void 0 : inputAddress1.street,
                        onChange: function(value) {
                            return onChange(value, 'street');
                        }
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Information_AreaAddressForm = (AreaAddressForm);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grow/Grow.js
var Grow = __webpack_require__(20170);
// EXTERNAL MODULE: ./components/Global/GoogleMapsApi.tsx
var GoogleMapsApi = __webpack_require__(98183);
;// CONCATENATED MODULE: ./components/Information/GoogleMapAddressForm.tsx
/* provided dependency */ var process = __webpack_require__(34155);










function GoogleMapAddressForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GoogleMapAddressForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GoogleMapAddressForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var STREET_NUMBER_AFTER_STREET = [
    'DE'
];
var GoogleMapAddressForm_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        marginBottom: {
            marginBottom: theme.spacing(2)
        }
    });
});
var GoogleMapAddressForm = function(param) {
    var _account = param.account, account = _account === void 0 ? false : _account, _prefill = param.prefill, prefill = _prefill === void 0 ? false : _prefill, _defaultAddress = param.defaultAddress, defaultAddress = _defaultAddress === void 0 ? null : _defaultAddress, addressType = param.addressType, _hideAdditionalAddress = param.hideAdditionalAddress, hideAdditionalAddress = _hideAdditionalAddress === void 0 ? false : _hideAdditionalAddress, className = param.className;
    var formatPayloadStreet = function formatPayloadStreet(countryCode, streetName, streetNumber) {
        if (STREET_NUMBER_AFTER_STREET.includes(countryCode)) {
            return "".concat(streetName).concat(streetNumber ? " ".concat(streetNumber) : '').trim();
        }
        return "".concat(streetNumber ? "".concat(streetNumber, " ") : '').concat(streetName).trim();
    };
    var formatPayloadAddress = function formatPayloadAddress(inputAddress, countries) {
        var street = inputAddress.street, streetNumber = inputAddress.streetNumber, postcode = inputAddress.postcode, city = inputAddress.city, country1 = inputAddress.country, details = inputAddress.details, areaCode = inputAddress.areaCode, // eslint-disable-next-line @typescript-eslint/no-unused-vars
        area = inputAddress.area;
        var isValid = postCodeRequired ? Boolean(street && postcode && city && country1 && streetNumber) : Boolean(street && city && country1 && streetNumber);
        var payloadAddress;
        if (isValid) {
            var ref;
            var countryCode = countries.filter(function(country) {
                return country.name === inputAddress.country;
            })[0].code.toUpperCase();
            payloadAddress = {
                street: formatPayloadStreet(countryCode, street, streetNumber),
                details: details === null || details === void 0 ? void 0 : details.trim(),
                postcode: postcode === null || postcode === void 0 ? void 0 : postcode.trim(),
                city: city.trim(),
                countryCode: countryCode
            };
            if (((ref = process.env.SEND_PROVINCE_CODE) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === 'true') {
                payloadAddress.provinceCode = areaCode === null || areaCode === void 0 ? void 0 : areaCode.trim();
            // We can't send both provinceName and provinceCode for now on sylius.
            // provinceName: area.trim(),
            }
        }
        return {
            isValid: isValid,
            payloadAddress: payloadAddress
        };
    };
    var getStreetAndStreetNumber = function getStreetAndStreetNumber(streetString, countryCode) {
        var splitStreetAndNumber = streetString === null || streetString === void 0 ? void 0 : streetString.split(' ');
        var street = streetString;
        var streetNumber;
        if ((splitStreetAndNumber === null || splitStreetAndNumber === void 0 ? void 0 : splitStreetAndNumber.length) > 1) {
            if (STREET_NUMBER_AFTER_STREET.includes(countryCode)) {
                var ref;
                streetNumber = splitStreetAndNumber[splitStreetAndNumber.length - 1];
                street = (ref = streetString === null || streetString === void 0 ? void 0 : streetString.split(String(streetNumber))[0]) === null || ref === void 0 ? void 0 : ref.trim();
            } else {
                var ref8;
                streetNumber = splitStreetAndNumber[0];
                street = (ref8 = streetString === null || streetString === void 0 ? void 0 : streetString.split(String(streetNumber))[1]) === null || ref8 === void 0 ? void 0 : ref8.trim();
            }
        }
        return {
            street: street,
            streetNumber: streetNumber
        };
    };
    var getStreet = function getStreet(streetString) {
        var splitStreetAndDetails = streetString === null || streetString === void 0 ? void 0 : streetString.split(' - ');
        return (splitStreetAndDetails === null || splitStreetAndDetails === void 0 ? void 0 : splitStreetAndDetails.length) ? splitStreetAndDetails[0] : streetString;
    };
    var initInputAddress = function initInputAddress(shippingAddress, countries) {
        var inputAddress;
        if (prefill && shippingAddress) {
            var ref, ref9;
            var city = shippingAddress.city, details = shippingAddress.details, postcode = shippingAddress.postcode, countryCode = shippingAddress.countryCode, provinceName = shippingAddress.provinceName, provinceCode = shippingAddress.provinceCode;
            var streetWithNumber = getStreet(shippingAddress.street);
            var ref10 = getStreetAndStreetNumber(streetWithNumber, countryCode), street = ref10.street, streetNumber = ref10.streetNumber;
            var country3 = (ref = countries.filter(function(country) {
                return country.code === shippingAddress.countryCode;
            })) === null || ref === void 0 ? void 0 : (ref9 = ref[0]) === null || ref9 === void 0 ? void 0 : ref9.name;
            inputAddress = {
                street: street,
                details: details,
                streetNumber: streetNumber,
                city: city,
                postcode: postcode,
                area: provinceName,
                areaCode: provinceCode,
                country: country3
            };
        } else if (prefill && defaultAddress && defaultAddress.street.length !== 0) {
            var city1 = defaultAddress.city, details1 = defaultAddress.details, postcode1 = defaultAddress.postcode, countryCode1 = defaultAddress.countryCode;
            var streetWithNumber1 = getStreet(defaultAddress.street);
            var ref11 = getStreetAndStreetNumber(streetWithNumber1, countryCode1), street1 = ref11.street, streetNumber1 = ref11.streetNumber;
            var country2 = countries.filter(function(country) {
                return country.code === defaultAddress.countryCode;
            })[0].name;
            inputAddress = {
                street: street1,
                details: details1,
                streetNumber: streetNumber1,
                city: city1,
                postcode: postcode1,
                country: country2
            };
        } else {
            inputAddress = {
                street: '',
                details: '',
                streetNumber: undefined,
                city: '',
                postcode: '',
                country: ''
            };
        }
        return inputAddress;
    };
    var onChange = function onChange(value, key) {
        saveInputAddress(GoogleMapAddressForm_objectSpread({}, inputAddress1, GoogleMapAddressForm_defineProperty({}, key, value)));
    };
    var ref7, ref1, ref2, ref3, ref4, ref5;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var postCodeRequired = ((ref7 = process.env.POSTCODE_REQUIRED) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()) !== 'false';
    var classes = GoogleMapAddressForm_useStyles();
    var prismicGeneral = (0,es/* useSelector */.v9)(function(state) {
        return state.prismic.general;
    });
    var prismicData = (0,es/* useSelector */.v9)(function(state) {
        return state.prismic[account ? 'account' : 'funnel'];
    });
    var ref6 = (0,useAddress/* useAddress */.S)(addressType, initInputAddress, formatPayloadAddress), saveSearchAddress = ref6.saveSearchAddress, address = ref6.address, saveInputAddress = ref6.saveInputAddress;
    (0,react.useEffect)(function() {
        if (address.search) {
            saveInputAddress({
                street: address.search.street,
                city: address.search.city,
                country: address.search.country,
                postcode: address.search.postcode,
                area: address.search.area,
                areaCode: address.search.areaCode,
                details: '',
                streetNumber: address.search.streetNumber
            });
        }
        if (address.search && !postCodeRequired) {
            saveInputAddress(GoogleMapAddressForm_objectSpread({}, address.search, {
                // add "00000" when postcode is not required (but it is on Sylius)
                postcode: address.search.postcode || '00000'
            }));
        }
    }, [
        address.search
    ]);
    var inputAddress1 = address.input;
    var text = function(key) {
        return (0,CMSText/* prismicText */.yz)(prismicData === null || prismicData === void 0 ? void 0 : prismicData[key], t("texts:account:".concat(key)));
    };
    var placeholder = (0,CMSText/* prismicText */.yz)(prismicGeneral === null || prismicGeneral === void 0 ? void 0 : prismicGeneral.placeholder, t('texts:general:search_address:placeholder'));
    var addressComplete = [
        address === null || address === void 0 ? void 0 : (ref1 = address.payload) === null || ref1 === void 0 ? void 0 : ref1.street,
        address === null || address === void 0 ? void 0 : (ref2 = address.payload) === null || ref2 === void 0 ? void 0 : ref2.city,
        (address === null || address === void 0 ? void 0 : (ref3 = address.payload) === null || ref3 === void 0 ? void 0 : ref3.postcode) === '00000' ? '' : address === null || address === void 0 ? void 0 : (ref4 = address.payload) === null || ref4 === void 0 ? void 0 : ref4.postcode,
        address === null || address === void 0 ? void 0 : (ref5 = address.payload) === null || ref5 === void 0 ? void 0 : ref5.countryCode, 
    ].filter(Boolean).join(' ');
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 1,
                className: (0,clsx_m/* default */.Z)(classes.marginBottom, className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMapsApi/* default */.Z, {
                        datas: prismicGeneral,
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: addressType === 'shipping' ? prismicGeneral === null || prismicGeneral === void 0 ? void 0 : prismicGeneral.label : undefined,
                            defaultText: addressType === 'billing' ? t('texts:general:search_address:label_billing') : t('texts:general:search_address:label')
                        }),
                        placeholder: placeholder,
                        saveSearchAddress: saveSearchAddress,
                        value: defaultAddress ? addressComplete : null
                    })
                })
            }),
            address.isPanelOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grow/* default */.Z, {
                in: true,
                mountOnEnter: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            container: true,
                            spacing: 1,
                            className: classes.marginBottom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 3,
                                    sm: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: text('street_number'),
                                        type: "text",
                                        name: "streetNumber",
                                        value: inputAddress1.streetNumber,
                                        onChange: function(value) {
                                            return onChange(value, 'streetNumber');
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 9,
                                    sm: 10,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: text('address'),
                                        placeholder: text('address'),
                                        type: "text",
                                        name: "address",
                                        value: inputAddress1.street,
                                        onChange: function(value) {
                                            return onChange(value, 'street');
                                        }
                                    })
                                })
                            ]
                        }),
                        !hideAdditionalAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            container: true,
                            spacing: 1,
                            className: classes.marginBottom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 8,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: text('address_details'),
                                        placeholder: text('address_details'),
                                        type: "text",
                                        name: "address-details",
                                        value: inputAddress1.details,
                                        onChange: function(value) {
                                            return onChange(value, 'details');
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: text('address_area'),
                                        placeholder: text('address_area'),
                                        type: "text",
                                        name: "address_area",
                                        value: inputAddress1.area,
                                        onChange: function(value) {
                                            return onChange(value, 'area');
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            container: true,
                            spacing: 1,
                            className: classes.marginBottom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 6,
                                    sm: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: text('postal_code'),
                                        placeholder: text('postal_code'),
                                        type: "text",
                                        name: "postcode",
                                        value: inputAddress1.postcode === '00000' ? '' : inputAddress1.postcode,
                                        onChange: function(value) {
                                            return onChange(value, 'postcode');
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 6,
                                    sm: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: text('country'),
                                        placeholder: text('country'),
                                        type: "text",
                                        name: "country",
                                        value: inputAddress1.country,
                                        disabled: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: text('town'),
                                        placeholder: text('town'),
                                        type: "text",
                                        name: "city",
                                        value: inputAddress1.city,
                                        onChange: function(value) {
                                            return onChange(value, 'city');
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var Information_GoogleMapAddressForm = (GoogleMapAddressForm);

;// CONCATENATED MODULE: ./components/Information/AddressForm.tsx
/* provided dependency */ var AddressForm_process = __webpack_require__(34155);





var AddressForm = function(param) {
    var _account = param.account, account = _account === void 0 ? false : _account, _prefill = param.prefill, prefill = _prefill === void 0 ? false : _prefill, _defaultAddress = param.defaultAddress, defaultAddress = _defaultAddress === void 0 ? null : _defaultAddress, _addressType = param.addressType, addressType = _addressType === void 0 ? 'shipping' : _addressType, _hideAdditionalAddress = param.hideAdditionalAddress, hideAdditionalAddress = _hideAdditionalAddress === void 0 ? false : _hideAdditionalAddress, className = param.className;
    var addressFormType = AddressForm_process.env.ADDRESS_TYPE;
    if (addressFormType === addressReducer/* AddressType.AREA */.DL.AREA) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Information_AreaAddressForm, {
            className: className,
            prefill: prefill,
            addressType: addressType
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Information_GoogleMapAddressForm, {
        className: className,
        account: account,
        prefill: prefill,
        defaultAddress: defaultAddress,
        addressType: addressType,
        hideAdditionalAddress: hideAdditionalAddress
    }));
};
/* harmony default export */ var Information_AddressForm = (AddressForm);


/***/ }),

/***/ 59361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useAddress; }
});

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
;// CONCATENATED MODULE: ./redux/actions/address.ts
var ACTIONS = {
    SAVE_SEARCH_ADDRESS: 'SAVE_SEARCH_ADDRESS',
    SAVE_INPUT_ADDRESS: 'SAVE_INPUT_ADDRESS',
    RESET_INPUT_ADDRESS: 'RESET_INPUT_ADDRESS',
    SAVE_PAYLOAD_ADDRESS: 'SAVE_PAYLOAD_ADDRESS'
};
var SAVE_SEARCH_ADDRESS = function(search, addressType) {
    return {
        type: ACTIONS.SAVE_SEARCH_ADDRESS,
        search: search,
        addressType: addressType
    };
};
var SAVE_INPUT_ADDRESS = function(input, isPanelOpen, addressType) {
    return {
        type: ACTIONS.SAVE_INPUT_ADDRESS,
        input: input,
        isPanelOpen: isPanelOpen,
        addressType: addressType
    };
};
var SAVE_PAYLOAD_ADDRESS = function(isValid, payload, addressType) {
    return {
        type: ACTIONS.SAVE_PAYLOAD_ADDRESS,
        isValid: isValid,
        payload: payload,
        addressType: addressType
    };
};
var RESET_INPUT_ADDRESS = function(addressType) {
    return {
        type: ACTIONS.RESET_INPUT_ADDRESS,
        addressType: addressType
    };
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useAddress.ts



function useAddress() {
    var addressType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'shipping', initInputAddress = arguments.length > 1 ? arguments[1] : void 0, formatPayloadAddress = arguments.length > 2 ? arguments[2] : void 0;
    var dispatch = (0,es/* useDispatch */.I0)();
    var address = (0,es/* useSelector */.v9)(function(state) {
        return state.inputAddress[addressType];
    });
    var countries = (0,es/* useSelector */.v9)(function(state) {
        return state.parameters.countries;
    });
    var currentAddress = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return addressType === 'shipping' ? (ref = state.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.shippingAddress : ((ref2 = state.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.billingAddress) || ((ref4 = state.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : ref5.address);
    });
    var saveSearchAddress = (0,react.useCallback)(function(searchAddress) {
        dispatch(SAVE_SEARCH_ADDRESS(searchAddress, addressType));
    }, [
        addressType
    ]);
    var saveInputAddress = (0,react.useCallback)(function(inputAddress) {
        dispatch(SAVE_INPUT_ADDRESS(inputAddress, true, addressType));
    }, [
        addressType
    ]);
    var resetInputAddress = (0,react.useCallback)(function() {
        dispatch(RESET_INPUT_ADDRESS(addressType));
    }, [
        addressType
    ]);
    (0,react.useEffect)(function() {
        if (initInputAddress) {
            var inputAdress = initInputAddress(currentAddress, countries);
            var isPanelOpen = Boolean(inputAdress.street);
            dispatch(SAVE_INPUT_ADDRESS(inputAdress, isPanelOpen, addressType));
        }
    }, []);
    (0,react.useEffect)(function() {
        if ((address === null || address === void 0 ? void 0 : address.input) && formatPayloadAddress) {
            var ref = formatPayloadAddress(address.input, countries), payloadAddress = ref.payloadAddress, isValid = ref.isValid;
            dispatch(SAVE_PAYLOAD_ADDRESS(isValid, payloadAddress, addressType));
        }
    }, [
        address === null || address === void 0 ? void 0 : address.input
    ]);
    return {
        address: address,
        resetInputAddress: resetInputAddress,
        saveSearchAddress: saveSearchAddress,
        saveInputAddress: saveInputAddress
    };
}


/***/ }),

/***/ 64063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ SAVE_PRISMIC_DOCUMENTS; }
/* harmony export */ });
/* unused harmony export ACTIONS */
var ACTIONS = {
    SAVE_PRISMIC_DOCUMENTS: 'SAVE_PRISMIC_DOCUMENTS'
};
var SAVE_PRISMIC_DOCUMENTS = function(data) {
    return {
        type: ACTIONS.SAVE_PRISMIC_DOCUMENTS,
        data: data
    };
};


/***/ })

}]);